/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PerformanceModalChartSection_projectStats = ReadonlyArray<{
    readonly id: string;
    readonly date: string | null;
    readonly performance: number | null;
    readonly optimisticPerformance: number | null;
    readonly conservativePerformance: number | null;
    readonly " $refType": "PerformanceModalChartSection_projectStats";
}>;
export type PerformanceModalChartSection_projectStats$data = PerformanceModalChartSection_projectStats;
export type PerformanceModalChartSection_projectStats$key = ReadonlyArray<{
    readonly " $data"?: PerformanceModalChartSection_projectStats$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PerformanceModalChartSection_projectStats">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PerformanceModalChartSection_projectStats",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "performance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optimisticPerformance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "conservativePerformance",
      "storageKey": null
    }
  ],
  "type": "ProjectStats"
};
(node as any).hash = 'fd4afecea4c4fc08e771a4b0e2e82d9c';
export default node;
